import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import {
  ITaskTemplateAuthPageRequest,
  ITaskTemplateAuthPageItem,
  ITaskTemplateAuthOperateRequest,
  ITaskTemplateAuthOperateResponse,
  ICreateTaskRequest,
  ICreateTaskResponse,
  ITaskPageItem,
  ITaskListParam,
  ITaskDetail,
  ICopyTaskRequest,
  IReadTemplateParams,
  IReadTemplate,
  ICalculateTaxesParams,
  IDutySignUpUser,
  IOrderDetailAddMain,
  ICalculateCommit,
  IDealErrorPersonParams,
  IDutyDistributionTempParams,
  IDutyDeliver,
  IDutyDeliverUploadParams,
  ITaxCalculatorRequest,
  ITaxCalculatorDetail,
  ITaskListItem,
  IHnLimit,
} from '../../types/crowd-source/task';
import { IStepItem } from '@vue3/components';
import { ITradeDetail } from '../../types/system/base/industry';
import { ITaskTemplateDetail } from '../../types/system/base/task-template';
import { EProxyPayType } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 查询任务模板授权分页列表
 * @param params 查询参数
 */
export async function queryTaskTemplateAuthPage(params: ITaskTemplateAuthPageRequest) {
  let data = [] as ITaskTemplateAuthPageItem[];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{data: ITaskTemplateAuthPageItem[];total: number}>(
      `${hostUrl}/side/duty/temp-authorize/page`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: ITaskTemplateAuthPageItem[]; total: number };

      data = items || [];
      total = all || 0;
      return {
        data,
        total,
      };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 新建授权
 * @param params 输入参数
 */
export async function AuthorizeTemp(params: { companyId: number;tempIdList: number[]; dutyType: number }) {
  try {
    const { code, message } = await Http.post<any>(
      `${hostUrl}/side/duty/temp-authorize/add`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return true;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 操作任务模板授权
 * @param params 操作参数
 */
export async function operateTaskTemplateAuth(params: ITaskTemplateAuthOperateRequest) {
  try {
    const { code, message } = await Http.post<ITaskTemplateAuthOperateResponse>(
      `${hostUrl}/side/duty/temp-authorize/update`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return { data: true };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 创建任务
 * @param params 创建任务参数
 */
export async function createTask(params: ICreateTaskRequest) {
  try {
    const { code, message } = await Http.post<ICreateTaskResponse>(
      `${hostUrl}/side/duty/duty-info/create`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return { data: true };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 重新提交任务
 * @param params 创建任务参数
 */
export async function resubmitTask(params: ICreateTaskRequest) {
  try {
    const { code, message } = await Http.post<ICreateTaskResponse>(
      `${hostUrl}/side/duty/duty-info/resubmit`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return {
        data: true,
        code, 
      };
    } else if (code === '999') {
      return {
        data: message,
        code, 
      };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 分页查询任务列表
 * @param params 查询参数
 */
export async function queryTaskPage(params: ITaskListParam) {
  let data = [] as ITaskPageItem[];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{data: ITaskPageItem[];total: number}>(
      `${hostUrl}/side/duty/duty-info/page`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: ITaskPageItem[]; total: number };

      data = items || [];
      total = all || 0;
      return {
        data,
        total,
      };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 查询任务详情
 * @param id 任务ID
 */
export async function queryTaskDetail(id: number, refresh?: number) {
  try {
    const { code, context, message } = await Http.get<ITaskDetail>(
      `${hostUrl}/side/duty/duty-info/detail`,
      {
        id,
        refresh, 
      },
    );

    if (code === EAxiosResponseCode.Succeed) {
      return { data: context };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 删除任务
 * @param params 输入参数
 */
export async function deleteDuty(params: { id: number }) {
  try {
    const { code, message } = await Http.get<any>(
      `${hostUrl}/side/duty/duty-info/delete`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return true;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 完结任务
 * @param params 输入参数
 */
export async function finishDuty(params: { id: number }) {
  try {
    const { code, message } = await Http.get<any>(
      `${hostUrl}/side/duty/duty-info/finish`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return true;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 复制任务
 * @param params 复制任务参数
 */
export async function copyTaskNeed(params: ICopyTaskRequest) {
  try {
    const { code, context, message } = await Http.post<any>(
      `${hostUrl}/side/duty/duty-info/copy`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return { data: context };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 进行中任务查询
 */
export async function queryProgressTask(dutyType: number) {
  let data = [] as ITaskListItem[];

  try {
    const { code, context, message } = await Http.get<ITaskListItem[]>(
      `${hostUrl}/side/duty/duty-info/progress-duty`,
      { dutyType },
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || data;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

export enum ETaskDistributeKey {
  Import = 'import',
  CountTax = 'countTax',
  Submit = 'submit',
}

export function getTaskDistributeSteps(): IStepItem<ETaskDistributeKey>[] {

  return [
    {
      title: '人员信息导入',
      key: ETaskDistributeKey.Import,
    },
    {
      title: '计算税费',
      key: ETaskDistributeKey.CountTax,
    },
    {
      title: '生成订单',
      key: ETaskDistributeKey.Submit,
    },

  ].filter(Boolean);

}

export function getTaskDistributeStep(current: ETaskDistributeKey): IStepItem<ETaskDistributeKey> | undefined {
  const steps = getTaskDistributeSteps();
  const index = steps.findIndex((item) => item.key === current);

  return steps[index - 1];
}

/**
 * 派发 - 派发前置校验
 * @param params 参数
 */
export async function dutyDistributePreCheck(id: number) {
  let res = {} as IHnLimit;

  try {
    const { code, context, message } = await Http.get<any>(
      `${hostUrl}/side/duty/duty-distribute/pre-check`, { id },
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 派发 - 人员信息导入(模版读取)
 * @param params 参数
 */
export async function dutyDistributeReadTemp(params: IReadTemplateParams) {
  let res = {} as IReadTemplate;

  try {
    const { code, context, message } = await Http.post<IReadTemplate>(
      `${hostUrl}/side/duty/duty-distribute/read-temp`, params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || {} as IReadTemplate;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 派发 - 计算税费前校验
 * @param params 参数
 */
export async function dutyDistributePreCheckCalculateTaxes(params: ICalculateTaxesParams) {
  let res = {} as IReadTemplate;

  try {
    const { code, context, message } = await Http.post<IReadTemplate>(
      `${hostUrl}/side/duty/duty-distribute/pre-check/calculate-taxes`, params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || {} as IReadTemplate;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 派发 - 异常人员处理
 * @param params 参数
 */
export async function dutyDistributeDealErrorPerson(params: IDealErrorPersonParams) {
  let res = {} as any;

  try {
    const { code, context, message } = await Http.post<any>(
      `${hostUrl}/side/duty/duty-distribute/deal-error-person`, params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 派发 - 计算税费
 * @param params 参数
 */
export async function dutyDistributeCalculateTaxes(params: ICalculateTaxesParams) {
  let res = {} as IOrderDetailAddMain;

  try {
    const { code, context, message } = await Http.post<IOrderDetailAddMain>(
      `${hostUrl}/side/duty/duty-distribute/calculate-taxes`, params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || {} as IOrderDetailAddMain;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 派发 - 提交订单
 * @param params 参数
 */
export async function dutyDistributeCalculateCommit(params: IOrderDetailAddMain) {
  let res = {} as ICalculateCommit;

  try {
    const { code, context, message } = await Http.post<ICalculateCommit>(
      `${hostUrl}/side/duty/duty-distribute/calculate-commit`, params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || {} as ICalculateCommit;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 派发 - 下载错误报告模板
 * @param params 参数
 */
export async function dutyDistributeDownloadErrorTemp(params: ICalculateTaxesParams) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  try {
    const { code, context, message, headers } = await Http.post<Blob>(
      `${hostUrl}/side/duty/duty-distribute/download-error-temp`, params, { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName, 
  };
}

/**
 * 任务管理 - 报名人员信息
 * @param id 参数
 */
export async function dutyInfoSignUpUser(id: number) {
  let res = [] as IDutySignUpUser[];

  try {
    const { code, context, message } = await Http.get<IDutySignUpUser[]>(
      `${hostUrl}/iam/customer/sign-up-user`, { id },
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || [] as IDutySignUpUser[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 任务管理 - 获取报名二维码
 * @param id 参数
 */
export async function dutyInfoQrcode(id: number) {
  let res = '';

  try {
    const { code, context, message } = await Http.get<string>(
      `${hostUrl}/side/duty/duty-info/qrcode`, { id },
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || '';
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 导出报名人员信息
 * @param id 任务ID
 */
export async function exportSignUpUser(id: number) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/iam/customer/export-sign-up-user`,
      { id },
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 任务管理 - 任务模版授权 - 获取已授权任务模板对应的行业列表
 * @param id 参数
 */
export async function queryTempAuthorizeIndustry(dutyType?: number) {
  let res = [] as ITradeDetail[];

  try {
    const { code, context, message } = await Http.get<ITradeDetail[]>(
      `${hostUrl}/side/duty/temp-authorize/list-industry`, { dutyType },
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || [] as ITradeDetail[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 任务管理 - 任务模版授权 - 列表
 * @param id 参数
 */
export async function queryTempAuthorizeList(dutyType: number, proxyPayType?: EProxyPayType) {
  let res = [] as ITaskTemplateDetail[];

  try {
    const { code, context, message } = await Http.get<ITaskTemplateDetail[]>(
      `${hostUrl}/side/duty/temp-authorize/list`, {
        dutyType,
        proxyPayType, 
      },
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || [] as ITaskTemplateDetail[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 派发 - 撮合派发模版下载(文件流直接下载)
 * @param params 参数
 */
export async function dutyDistributeDownloadTemp(params: IDutyDistributionTempParams) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  try {
    const { code, context, message, headers } = await Http.get<Blob>(
      `${hostUrl}/side/duty/duty-distribute/download-temp`,
      params,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName,
  };
}

/**
 * 任务管理 - 任务派发 - 校验当前产品是否有支付宝通道
 * @param id 参数
 */
export async function alipayChannelCheck(id: number) {
  let res = false;

  try {
    const { code, context, message } = await Http.get<boolean>(
      `${hostUrl}/side/duty/duty-distribute/alipay-channel-check`, { id },
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return res;
}

/**
 * 列表 - 导出
 * @param params 参数
 */
export async function exportTaskPage(params: ITaskListParam) {
  let buffer = null as Blob | null;
  let fileName = ''; // 默认文件名

  try {
    const { code, context, message, headers } = await Http.get<Blob>(
      `${hostUrl}/side/duty/duty-info/export`,
      params,
      { responseType: 'blob' },
    );

    if (headers['content-disposition']) {
      const match = headers['content-disposition'].match(/filename=(.+);?/);

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim().replace(/"/g, ''));
      }
    }

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    buffer,
    fileName,
  };
}

/**
 * 交付物列表
 * @param dutyId 任务ID
 */
export async function queryDeliverList(dutyId: number) {
  let data = [] as IDutyDeliver[];

  try {
    const { code, context, message } = await Http.get<IDutyDeliver[]>(
      `${hostUrl}/side/duty/duty-info/deliver-list`,
      { dutyId },
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || data;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 上传交付物
 * @param params 输入参数
 */
export async function deliverUpload(params: IDutyDeliverUploadParams) {
  try {
    const { code, message, context } = await Http.post(
      `${hostUrl}/side/duty/duty-info/deliver-upload`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 查询任务详情
 * @param deliverId 交付物ID
 */
export async function queryDeliverDetail(deliverId: number) {
  try {
    const { code, context, message } = await Http.get<IDutyDeliver>(
      `${hostUrl}/side/duty/duty-info/deliver-detail`,
      { deliverId },
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
/** 税费计算器 */
export async function taxCalculator(params: ITaxCalculatorRequest) {
  let res = {} as ITaxCalculatorDetail;

  try {
    const { code, context, message } = await Http.post<ITaxCalculatorDetail>(
      `${hostUrl}/side/duty/duty-info/tax-calculator`, params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      res = context || {} as ITaxCalculatorDetail;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  return res;
}
